import { auctionUser } from '@/helpers/constant';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuctionService } from '@services/auction/auction.service';
import { InventoryService } from '@services/inventory/inventory.service';
import { SharedService } from '@services/shared/shared.service';
import { UserService } from '@services/user/user.service';
import { environment } from 'environments/environment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

interface SpecField {
  key: string;
  label: string;
  icon: string;
  isDate?: boolean;
}

@Component({
  selector: 'app-purchase-details',
  templateUrl: './purchase-details.component.html',
  styleUrls: ['./purchase-details.component.scss'],
})
export class PurchaseDetailsComponent implements OnInit {
  env: string = environment.forntend_url;
  paymentId: string = '';
  loading: boolean = false;
  laddaLoading: boolean = false;
  paymentInfo: object[] = [];
  lang: 'ar' | 'en' | string = 'en';
  paymentDocs: object[] = [];
  laddaSellButton: boolean = false;
  invoice: object[] = [];
  productId: string = '';
  invoiceAvailable: boolean = false;
  invoiceUrl: string = '';
  uploadBtnStatus: boolean = true;
  laddaBtnStates: boolean[] = [];
  laddaBtnStatesInModal: boolean[] = [];
  enableReserve: boolean = false;
  fullPaymentStatus: boolean = false;
  reserveStatus: 'Reserved' | 'Not Reserved';
  laddaReserveBtn: boolean = false;
  showSellOption: boolean = false;
  whyReject: string = '';
  rejectedDocId: string = '';
  rejectedDocName: string = '';
  rejectedDocIndex: number = -1;
  rejectLaddaBtn: boolean = false;
  employeeList: object[] = [];
  employeeEmail: string = '';
  employeePhone: string = '';
  employeeName: string = '';

  modalRef?: BsModalRef;
  modalConfig = {
    ignoreBackdropClick: true,
    class: 'modal-lg',
  };

  globalDocsObj = {
    'Payment Receipts': {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
    Invoice: {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
    'Sales Order': {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
    'Approved Delivery Note': {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
    'Transferred ISTIMARA ( Registration card )': {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
  };

  // Full catalogue of vehicle spec fields we know how to display.
  // Only fields that actually have a value on the current vehicle are rendered,
  // so the panel is as dense (or as sparse) as the real data allows.
  vehicleSpecFields: SpecField[] = [
    { key: 'Make', label: 'Make', icon: 'business-outline' },
    { key: 'Model', label: 'Model', icon: 'car-sport-outline' },
    { key: 'Trim/Type', label: 'Trim / Type', icon: 'options-outline' },
    { key: 'Model Year', label: 'Model Year', icon: 'calendar-outline' },
    { key: 'VIN Number', label: 'VIN', icon: 'barcode-outline' },
    { key: 'Plate Number', label: 'Plate Number', icon: 'pricetag-outline' },
    { key: 'Body Type', label: 'Body Type', icon: 'car-outline' },
    { key: 'Vehicle Type', label: 'Vehicle Type', icon: 'bus-outline' },
    { key: 'Condition', label: 'Condition', icon: 'checkmark-done-outline' },
    { key: 'Origin', label: 'Origin', icon: 'globe-outline' },
    { key: 'Ownership', label: 'Ownership', icon: 'person-outline' },
    { key: 'Utility Type', label: 'Utility Type', icon: 'briefcase-outline' },
    { key: 'Engine Type', label: 'Engine Type', icon: 'flash-outline' },
    { key: 'CC', label: 'Engine CC', icon: 'speedometer-outline' },
    { key: 'Cylinders', label: 'Cylinders', icon: 'construct-outline' },
    { key: 'Fuel Type', label: 'Fuel Type', icon: 'water-outline' },
    { key: 'Transmission Type', label: 'Transmission', icon: 'settings-outline' },
    { key: 'Gear', label: 'Gears', icon: 'cog-outline' },
    { key: 'Drive Type', label: 'Drive Type', icon: 'navigate-outline' },
    { key: 'HP (Horse Power)', label: 'Horse Power', icon: 'speedometer-outline' },
    { key: 'Torque', label: 'Torque', icon: 'flash-outline' },
    { key: 'Max Speed', label: 'Max Speed', icon: 'rocket-outline' },
    { key: 'Accleration', label: '0–100 km/h', icon: 'timer-outline' },
    { key: 'ODO', label: 'Odometer (KM)', icon: 'speedometer-outline' },
    { key: 'Mileage', label: 'Mileage', icon: 'trail-sign-outline' },
    { key: 'Exterior Colour', label: 'Exterior Colour', icon: 'brush-outline' },
    { key: 'Interior Colour', label: 'Interior Colour', icon: 'color-palette-outline' },
    { key: 'Upholstery', label: 'Upholstery', icon: 'layers-outline' },
    { key: 'Doors', label: 'Doors', icon: 'exit-outline' },
    { key: 'Seat', label: 'Seats', icon: 'people-outline' },
    { key: 'Wheel Base', label: 'Wheel Base', icon: 'resize-outline' },
    { key: 'Warranty', label: 'Warranty', icon: 'shield-checkmark-outline' },
    { key: 'Warranty expiry date', label: 'Warranty Expiry', icon: 'calendar-outline', isDate: true },
    { key: 'Estimara', label: 'Estimara', icon: 'document-text-outline' },
    { key: 'Estimara expiry date', label: 'Estimara Expiry', icon: 'calendar-outline', isDate: true },
    { key: 'MVPI expiry date', label: 'MVPI Expiry', icon: 'calendar-outline', isDate: true },
    { key: 'Service and maintenance status', label: 'Service Status', icon: 'build-outline' },
    { key: 'Last service date', label: 'Last Service', icon: 'calendar-outline', isDate: true },
    { key: 'Assessment Type', label: 'Assessment Type', icon: 'ribbon-outline' },
    { key: 'Vendor', label: 'Vendor', icon: 'storefront-outline' },
    { key: 'Yard Type', label: 'Yard', icon: 'location-outline' },
    { key: 'Finance Status', label: 'Finance Status', icon: 'card-outline' },
  ];

  // Key financial figures pulled out of description_data for the summary strip.
  financialFields: SpecField[] = [
    { key: 'price', label: 'Purchase Price', icon: 'cash-outline' },
    { key: 'COD', label: 'COD', icon: 'wallet-outline' },
    { key: 'calculated_value', label: 'Calculated Value', icon: 'analytics-outline' },
  ];

  constructor(
    private route: ActivatedRoute,
    private inventoryService: InventoryService,
    private sharedService: SharedService,
    private auctionService: AuctionService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private userService: UserService
  ) {
    const paymentId = this.route.snapshot.paramMap.get('paymentId');

    if (paymentId) {
      this.paymentId = paymentId;
    }
  }

  ngOnInit(): void {
    this.getPaymentInfo();
  }

  getPaymentInfo() {
    this.loading = true;
    this.inventoryService.purchaseView(this.paymentId).subscribe((res) => {
      if (res['success']) {
        this.sharedService.modifiedData([res['data']]);
        this.paymentInfo = res['data'];
        this.paymentDocs = res['data']['userPaymentDoc'] || [];
        this.reserveStatus =
          res['data']['payment_order_type_status'] === true
            ? 'Reserved'
            : 'Not Reserved';

        this.loading = false;
        this.productId = res['data']['product_id'];
        this.getVehicleImage(res['data']);
        this.reserveAndFinanceStatus();
        this.showSellBtn();
      }
    });
  }

  // Returns the active description dataset (Arabic or English) based on the current language.
  get activeDescriptionData(): object {
    if (!this.paymentInfo) {
      return {};
    }
    return this.lang === 'ar'
      ? this.paymentInfo['description_data_ar'] || {}
      : this.paymentInfo['description_data'] || {};
  }

  toggleLang(lang: 'en' | 'ar') {
    this.lang = lang;
  }

  // Returns the value for a spec field key, or null when there is nothing worth showing.
  getSpecValue(key: string): string | null {
    const value = this.activeDescriptionData?.[key];
    return value !== undefined && value !== null && value !== '' ? value : null;
  }

  viewDocument(docUrl: string) {
    window.open(docUrl, '_blank');
  }

  updatePaymentStatus(productId: string, status: string, vehicleId: string) {
    this.laddaSellButton = true;

    const payload = {
      approve: status,
      payment_id: this.paymentId,
    };

    let auctionToken = JSON.parse(localStorage.getItem('auctionUser'));
    if (auctionToken) {
      this.checkVehicleStatus(vehicleId, productId, payload, 'sell');
    } else {
      this.auctionAuthCheck(vehicleId, productId, payload, 'sell');
    }
  }

  // auction user check and get token of the user.
  auctionAuthCheck(vehicleId, productId, payload, type) {
    this.auctionService.auctionAuthenticationCheck(auctionUser).subscribe(
      (res) => {
        if (res['success']) {
          localStorage.setItem('auctionUser', JSON.stringify(res));
          if (type === 'sell') {
            this.checkVehicleStatus(vehicleId, productId, payload, 'sell');
          } else {
            // As per discussion lock api also call during reserve.
            this.checkReserveVehicleStatus(
              vehicleId,
              productId,
              payload,
              'reserve'
            );
          }
        }
      },
      (error: HttpErrorResponse) => {
        this.toastr.error('Something went wrong!');
        this.loading = false;
      }
    );
  }

  // vehicle log status check and if success then update payment status check.
  checkVehicleStatus(vehicleId?: string, productId?, payload?, type = 'sell') {
    const params = {
      vehicle_id: vehicleId,
      is_sold: 1,
      is_reserved: 1,
    };
    this.VehicleStatusApiCall(params, vehicleId, productId, payload, type);
  }

  updateReserveStatus(productId: string, status: string, vehicleId: string) {
    this.laddaReserveBtn = true;

    const payload = {
      approve_order_type: status,
      payment_id: this.paymentId,
    };

    // As per discussion lock api also call during reserve.
    let auctionToken = JSON.parse(localStorage.getItem('auctionUser'));
    if (auctionToken) {
      this.checkReserveVehicleStatus(vehicleId, productId, payload, 'reserve'); // vehicle log api call.
    } else {
      this.auctionAuthCheck(vehicleId, productId, payload, 'reserve'); // If token not available in the local storage.
    }
  }

  checkReserveVehicleStatus(vehicleId, productId, payload, type) {
    var params = {
      vehicle_id: vehicleId,
      is_reserved: +payload.approve_order_type,
    };

    this.VehicleStatusApiCall(params, vehicleId, productId, payload, type);
  }

  VehicleStatusApiCall(formData: any, vehicleId, productId, payload, type) {
    this.auctionService.vehicleStatusCheck(formData).subscribe(
      (res: HttpResponse<any>) => {
        if (res.body['success'] && formData.is_sold) {
          this.auctionService
            .updatePaymentStatus(productId, payload)
            .subscribe((res) => {
              if (res['success']) {
                this.paymentInfo['buy_status'] = '2';
              }
              this.laddaSellButton = false;
            });
        } else if (res.body['success'] && !formData.is_sold) {
          this.inventoryService
            .vehicleReserveStatus(productId, payload)
            .subscribe((res) => {
              if (res['success']) {
                this.reserveStatus === 'Reserved'
                  ? (this.reserveStatus = 'Not Reserved')
                  : (this.reserveStatus = 'Reserved');
                this.paymentInfo['payment_order_type_status'] =
                  !this.paymentInfo['payment_order_type_status'];
                this.toastr.success(res['message']);
              }
              this.laddaReserveBtn = false;
            });
        } else {
          // if unsuccess or token expired then auth token api call.
          this.auctionAuthCheck(vehicleId, productId, payload, type);
        }
      },
      (error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.auctionAuthCheck(vehicleId, productId, payload, type);
        } else {
          this.toastr.error('Something went wrong!');
        }
        this.loading = false;
      }
    );
  }

  getVehicleImage(vehicleDetails: object) {
    let frontImg = '';
    let imgBaseUrl = '';

    if (vehicleDetails['type'] === '2') {
      imgBaseUrl = environment.auctionBaseUrl;
    } else {
      imgBaseUrl = environment.imgBaseUrl;
    }

    if (
      vehicleDetails?.['vehicle_images']?.['parts_images'] &&
      vehicleDetails['vehicle_images']['parts_images'].length
    ) {
      for (
        let i = 0;
        i < vehicleDetails['vehicle_images']['parts_images'].length;
        i++
      ) {
        if (
          vehicleDetails['vehicle_images']['parts_images'][i]?.['part_name'] ===
          'Front'
        ) {
          frontImg =
            imgBaseUrl +
            vehicleDetails['vehicle_images']['parts_images'][i]['image'];
          break;
        }
      }
    } else if (vehicleDetails?.['productImageUrl']?.[0]?.['presigned_url']) {
      frontImg = vehicleDetails['productImageUrl'][0]['presigned_url'];
    } else if (vehicleDetails?.['imageUrl']?.[0]?.['presigned_url']) {
      frontImg = vehicleDetails['imageUrl'][0]['presigned_url'];
    } else {
      frontImg = this.env + 'assets/img/car-placeholder.png';
    }

    vehicleDetails['frontImg'] = frontImg;
  }

  getBase64(blob: Blob) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  async getDocument(event: Event, docName: string) {
    const document = (event.target as HTMLInputElement).files[0];
    const base64: any = await this.getBase64(document);

    let base64WithOutType: string;

    if (document.type === 'image/jpeg') {
      base64WithOutType = base64.replace('data:image/jpeg;base64,', '');
    } else if (document.type === 'application/pdf') {
      base64WithOutType = base64.replace('data:application/pdf;base64,', '');
    }

    this.invoice.push({ image: base64WithOutType, name: docName });

    if (this.globalDocsObj[docName]) {
      this.globalDocsObj[docName]['enableUpload'] = true;
    }

    this.uploadBtnStatus = false;
  }

  uploadDocument(productId: string, docName: string, index: number) {
    this.laddaBtnStatesInModal[index] = true;
    const docToUpload: object[] = [];

    this.invoice.forEach((doc) => {
      if (doc['name'] === docName) {
        docToUpload.push(doc);
      }
    });

    if (!docToUpload.length) {
      this.laddaBtnStatesInModal[index] = false;
      return this.toastr.error('No Document found with this name: ' + docName);
    }

    const payload = {
      documents: docToUpload,
    };

    this.inventoryService.uploadPurchaseInvoice(productId, payload).subscribe(
      (res) => {
        if (res['success']) {
          this.laddaBtnStatesInModal[index] = false;
          this.toastr.success(res['message']);
          this.getPurchaseInvoice(productId);
        }

        this.laddaLoading = false;
      },
      (error) => {
        this.laddaLoading = false;
        console.error(error);
      }
    );
  }

  getPurchaseInvoice(productId: string, docToDelete?: string) {
    if (docToDelete) {
      this.globalDocsObj[docToDelete]['available'] = false;
      this.globalDocsObj[docToDelete]['enableUpload'] = false;
    }

    this.inventoryService.getPurchaseInvoice(productId).subscribe((res) => {
      res['data']['invoice_doc']?.forEach((doc) => {
        if (this.globalDocsObj[doc['document_name']]) {
          this.globalDocsObj[doc['document_name']]['available'] = true;
          this.globalDocsObj[doc['document_name']]['imageUrl'] =
            doc['imageUrl']['presigned_url'];
          this.globalDocsObj[doc['document_name']]['id'] = doc['doc_id'];
          this.globalDocsObj[doc['document_name']]['uploadTime'] =
            doc['created_at'];
        }
      });
    });
  }

  viewPurchaseInvoice(invoiceUrl: string) {
    window.open(invoiceUrl, '_blank');
  }

  deleteAfterSellDocs(
    productId: string,
    docId: string,
    docName: string,
    index: number
  ) {
    this.laddaBtnStatesInModal[index] = true;

    const payload = {
      product_invoice_id: docId,
    };

    this.inventoryService.deleteAfterSellDocs(productId, payload).subscribe(
      (res) => {
        if (res['success']) {
          this.laddaBtnStatesInModal[index] = false;
          this.toastr.success(res['message']);
          this.getPurchaseInvoice(productId, docName);
        }
      },
      (error) => {
        this.laddaBtnStatesInModal[index] = false;
        console.error(error);
      }
    );
  }

  userDocStatusUpdate(docId: string, status: string, laddaIndex: number) {
    let payload: object;

    if (status === '0') {
      this.rejectLaddaBtn = true;
      payload = {
        document_id: docId,
        document_status: status,
        notes: this.whyReject,
      };
    } else {
      payload = {
        document_id: docId,
        document_status: status,
      };
    }

    this.laddaBtnStates[laddaIndex] = true;

    this.inventoryService
      .userDocApproveReject(this.paymentId, payload)
      .subscribe((res) => {
        if (res['success']) {
          this.laddaBtnStates[laddaIndex] = false;
          this.rejectLaddaBtn = false;
          this.modalRef?.hide();
          this.paymentDocs[laddaIndex]['order_document_status'] =
            status === '1' ? true : false;
          this.showSellBtn();
          this.checkForReserveSlipApprove();
        }
      });
  }

  reserveAndFinanceStatus() {
    this.paymentDocs?.forEach((doc) => {
      if (doc['document_name'] === 'Reserve Slip') {
        doc['order_document_status'] === true
          ? (this.enableReserve = true)
          : (this.enableReserve = false);
      }

      if (
        doc['document_name'] === 'Payment Receipt' &&
        this.paymentInfo['payment_order_type_status'] &&
        doc['order_document_status']
      ) {
        this.fullPaymentStatus = true;
      }
    });
  }

  showSellBtn() {
    this.paymentDocs?.forEach((doc) => {
      if (doc['document_name'] === 'Payment Receipt / Finance Receipt') {
        if (
          doc['order_document_status'] &&
          this.paymentInfo['payment_order_type_status']
        ) {
          this.showSellOption = true;
        } else {
          this.showSellOption = false;
        }
      }
    });
  }

  checkForReserveSlipApprove() {
    this.paymentDocs.forEach((doc) => {
      if (doc['document_name'] === 'Reserve Slip') {
        doc['order_document_status'] === true
          ? (this.enableReserve = true)
          : (this.enableReserve = false);
      }
    });
  }

  openDocsUploadModal(template: TemplateRef<any>) {
    this.getPurchaseInvoice(this.productId);
    this.modalRef = this.modalService.show(template, this.modalConfig);
  }

  openRejectWhyModal(
    template: TemplateRef<any>,
    docId: string,
    status: string,
    index: number,
    docName: string
  ) {
    this.rejectedDocId = docId;
    this.rejectedDocName = docName;
    this.rejectedDocIndex = index;
    this.modalRef = this.modalService.show(template, this.modalConfig);
  }

  onSubmitReject() {
    if (!this.whyReject) {
      return this.toastr.error('Please provide reason');
    }

    this.userDocStatusUpdate(this.rejectedDocId, '0', this.rejectedDocIndex);
  }

  openPDIModal(template: TemplateRef<any>) {
    const payload = {
      user_type: 1,
    };

    this.userService.userList(payload).subscribe((res) => {
      if (res['success']) {
        this.employeeList = res['data'];
      }
    });
    this.modalRef = this.modalService.show(template, {
      ignoreBackdropClick: true,
    });
  }

  onOptionChanged(index: number) {
    if (!index) {
      this.employeePhone = '';
      return;
    }

    this.employeePhone = this.employeeList[index]['phone'];
    this.employeeEmail = this.employeeList[index]['email'];
    this.employeeName =
      this.employeeList[index]['first_name'] +
      ' ' +
      this.employeeList[index]['last_name'];
  }

  completeSell() {
    if (!this.employeePhone) {
      this.toastr.error('Please select an employee!');
      return;
    }

    this.laddaSellButton = true;

    this.updatePaymentStatus(
      this.productId,
      '1',
      this.paymentInfo['vehicle_id']
    );

    let message = `Keep ready ${this.paymentInfo['vehicle_name']}`;
    message =
      message +
      `\nVIN - ${this.paymentInfo?.['description_data']?.['VIN Number']} \nREG - ${this.paymentInfo?.['description_data']?.['Plate Number']}`;
    message =
      message +
      `\nfor delivery on ${new Date(
        this.paymentInfo?.['order_date']
      ).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })} to ${this.paymentInfo['first_name']} ${this.paymentInfo['last_name']
      }`;

    const payload = {
      phone_number: this.employeePhone,
      pdi_message: message,
    };

    this.userService.userPDI(payload).subscribe((res) => {
      if (res['success']) {
        this.toastr.success(`PDI Notified to ${this.employeeName}`);
        this.modalRef?.hide();
      }

      this.laddaSellButton = false;
    });
  }
}